"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DynamicImport;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * ## Works only with `*.lazy.tsx`
 *
 * @example
 * ```tsx
 * import DynamicImport from '@insided/shared/utils/DynamicImport'
 * // Do not import your lazy component using static imports
 * import { RectangleSkeleton } from '@insided/shared/uikit/Skeleton'
 *
 * // Declare lazy component outside of render
 * const NoImage = DynamicImport(
 *   () => import('./NoImage.lazy'), // <- must be *.lazy.tsx
 *   { fallback: <RectangleSkeleton width="200px" height="100px" /> }
 * )
 *
 * // Use like a normal component
 * const MyComponent = () => (
 *  <div>
 *    <h2>Lazy loaded image:</h2>
 *    <NoImage className='event-item__no-image' />
 *  </div>
 * )
 * ```
 */
function DynamicImport(loader, options) {
  return /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(_class2, _Component);

    var _super = _createSuper(_class2);

    function _class2() {
      var _this;

      (0, _classCallCheck2.default)(this, _class2);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {});
      return _this;
    }

    (0, _createClass2.default)(_class2, [{
      key: "componentDidMount",
      value: function () {
        var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.t0 = this;
                  _context.next = 4;
                  return loader();

                case 4:
                  _context.t1 = _context.sent;
                  _context.t2 = {
                    component: _context.t1
                  };

                  _context.t0.setState.call(_context.t0, _context.t2);

                  _context.next = 12;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t3 = _context["catch"](0);

                  _logger.logger.error(_context.t3, {
                    component: 'DynamicImport',
                    phase: 'lazy-load'
                  });

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[0, 9]]);
        }));

        function componentDidMount() {
          return _componentDidMount.apply(this, arguments);
        }

        return componentDidMount;
      }()
    }, {
      key: "render",
      value: function render() {
        if (!this.state.component) {
          var _options$fallback;

          return (_options$fallback = options === null || options === void 0 ? void 0 : options.fallback) !== null && _options$fallback !== void 0 ? _options$fallback : null;
        }

        var InnerComponent = this.state.component.default;
        return (0, _preact.h)(InnerComponent, (0, _extends2.default)({}, this.props, {
          key: "lazy-component"
        }));
      }
    }]);
    return _class2;
  }(_preact.Component);
}